//REACT-JS
import React from 'react';
import { withRouter } from 'react-router-dom';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//COMPONENTS
import { relatorioAction } from '../../store/relatorio';

class TableVolumetriaUsuario extends React.Component {

    constructor(props) {
        super(props);
    }

    static defaultProps = {
        name: "",
        selected: 0,
        onChange: function(e){}
    };

    render() {

        const data = this.props.data; let html = "";

        if (data.results === undefined) {
            html = (<tr><td colSpan="7" scope="row">Carregando...</td></tr>);
        }
        else if (data.results.length === 0 || data.results === 0) {
            html = (<tr><td colSpan="7" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.results.length > 0) {
            html = data.results.map(row =>
                <tr key={row.identificador} id={row.codigo}>
                    <td>{row.identificador}</td>
                    <td>{row.usuario}</td>
                    <td>{row.mailing}</td>
                    <td>{row.tipoEnvio}</td>
                    <td>{row.volumeEmail}</td>
                    <td>{row.volumeSms}</td>
                </tr>                  
            );
        }

        return(
            <div style={{maxHeight: "400px", overflowY: "auto"}}>
                <table className="footable table table-striped toggle-arrow-tiny text-body" id="table-to-export">
                    <thead>
                        <tr style={{backgroundColor: "#dbf1e9"}}>       
                            <th>Identificador</th>
                            <th>Usuario</th>
                            <th>Mailing</th>
                            <th>Tipo de Envio</th>
                            <th>Volume Email</th>
                            <th>Volume Sms</th>
                        </tr>
                    </thead>

                    <tbody>{html}</tbody>
                </table>            
            </div>
        )
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth, relatorio: state.relatorio };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { relatorio: bindActionCreators(relatorioAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TableVolumetriaUsuario));